module.exports = __webpack_public_path__ + "media/img/boxed-bg-b6a91122.jpg";